import { NgModule } from '@angular/core';
import { MasterPrecheckResource } from '@blcloud/bl-ng-resource';
import { LoginPageService } from '../../../page/login-page/login-page.service';

@NgModule({
  providers: [
    LoginPageService,
    MasterPrecheckResource
  ],
})
export class AutoLoginModule {
}



// WEBPACK FOOTER //
// ./src/app/core/guard/auto-login/auto-login.module.ts